Service = App.loadClass 'core::Angular/Service'

class exports.RatingsService extends Service

    constructor: (@http, @rootScope, @factory) ->
        null
    # Categories

    getConfiguration: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/ratings/get-configuration', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                @_parseCategories(response.data.categories)
            return response

    _parseCategories: (categories) =>
        # NOTE: this will modify the array since it's passed by reference
        for category, i in categories
            for heading, j in category.headings
                for col, k in heading.columns
                    heading.columns[k] = @factory.make('Column', col)
                category.headings[j] = @factory.make('Heading', heading)
            categories[i] = @factory.make('Category', category)

    # Products

    getProducts: (lineups_id, ids = null) =>
        params =
            lineups_id: lineups_id

        if ids?
            params.ids = ids

        return @http.post('backend/portal/ratings/products/load-with-ratings', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.products
                    obj = @factory.make('ProductWithRatings', props)
                    response.data.products[i] = obj
            return response

    updateRatings: (lineups_id, products) =>
        params =
            lineups_id: lineups_id
            products: products

        # yo dawg, I heard you liked ratings.. :D
        return @http.post('backend/portal/ratings/ratings/update-ratings', params).then((response) -> response.data)

    getCompanyName: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/ratings/get-company-name', params).then((response) -> response.data)
